var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/marks/link/link-mark-editor-dialog.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import { goTo } from "@adornis/router/client/open-href.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { LINK_KEY } from "../../../schema/marks/link.js";
var LinkMarkEditorDialog = class extends XNativeDialog {
  static get element_name() {
    return "link-mark-editor-dialog";
  }
  static editLink({
    href,
    target,
    view,
    from,
    to
  }) {
    return this.showPopup({
      props: {
        href,
        target,
        view,
        from,
        to,
        mode: "edit"
      }
    });
  }
  static insertLink({
    href,
    target,
    view,
    from,
    to
  }) {
    return this.showPopup({
      props: {
        href,
        target,
        view,
        from,
        to,
        mode: "insert"
      }
    });
  }
  content() {
    return html`
      <x-grid ${css({ gap: "24px", padding: "16px" })} columns=${{ edit: "2fr 1fr", insert: "1" }[this.mode]}>
        <x-flex ${css({ gap: "24px", padding: "16px" })}>
          <x-text ${css({ fontSize: "24px" })}>
            <b> Link ${{ edit: "bearbeiten", insert: "einf\xFCgen" }[this.mode]} </b></x-text
          >
          <x-flex ${css({ gap: "8px" })}>
            <x-input
              placeholder="Link"
              .value=${this.href}
              @value-changed=${(e) => {
      this.href = e.detail.value;
    }}
            ></x-input>
            <x-checkbox
              .label=${"In neuem Fenster \xF6ffnen?"}
              .value=${this.target === "_blank"}
              @value-changed=${(e) => {
      this.target = e.detail.value ? "_blank" : "_self";
    }}
            ></x-checkbox>
            <x-flex horizontal space="sm" space-between ${css({ gap: "8px" })}>
              <x-button mode="outline" @click=${() => this.cancel()}> Abbrechen </x-button>
              <x-button
                @click=${() => {
      const tr = this.view.state.tr;
      this.view.dispatch(
        tr.addMark(
          this.from,
          this.to,
          this.view.state.schema.marks.link.create({ href: this.href, target: this.target })
        )
      );
      this.close();
    }}
              >
                ${{ edit: "Speichern", insert: "Erstellen" }[this.mode]}
              </x-button>
            </x-flex>
          </x-flex>
        </x-flex>
        ${this.mode === "edit" ? html`
              <x-flex ${css({ gap: "24px", padding: "16px" })}>
                <x-text ${css({ fontSize: "24px" })}> <b> Oder </b></x-text>
                <x-flex ${css({ gap: "8px" })}>
                  <x-button
                    tone="error"
                    @click=${() => {
      const linkMark = this.view.state.schema.mark[LINK_KEY];
      this.view.dispatch(this.view.state.tr.removeMark(this.from, this.to, linkMark));
      this.close();
    }}
                  >
                    Löschen
                  </x-button>
                  <x-button
                    @click=${() => {
      goTo(this.href, { target: this.target ?? "_blank" });
      this.close();
    }}
                  >
                    Öffnen
                  </x-button>
                </x-flex>
              </x-flex>
            ` : nothing}
      </x-grid>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        dialog: {
          display: "block",
          width: "min(700px, 90%)",
          boxSizing: "border-box"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], LinkMarkEditorDialog.prototype, "href", 2);
__decorateClass([
  property({ attribute: false })
], LinkMarkEditorDialog.prototype, "target", 2);
__decorateClass([
  property({ attribute: false })
], LinkMarkEditorDialog.prototype, "view", 2);
__decorateClass([
  property({ attribute: false })
], LinkMarkEditorDialog.prototype, "from", 2);
__decorateClass([
  property({ attribute: false })
], LinkMarkEditorDialog.prototype, "to", 2);
__decorateClass([
  property({ attribute: false })
], LinkMarkEditorDialog.prototype, "mode", 2);
LinkMarkEditorDialog = __decorateClass([
  customElement("link-mark-editor-dialog")
], LinkMarkEditorDialog);
export {
  LinkMarkEditorDialog
};
